import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ApplicationInformationService } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessExportPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessExportProperties = {
    [name in keyof EntityCommandProcessExportPropertyValues]: Property<EntityCommandProcessExportPropertyValues[name]>
};

export interface IEntityCommandProcessExport extends IEntityCommand, EntityCommandProcessExportProperties
{
}

export class EntityCommandProcessExport extends EntityCommand implements IEntityCommandProcessExport
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessExport";
    public static override className = "EntityCommandProcessExport";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessExportPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Export",
                entityName: "Process",
                key: "EXPORT",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessExportPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    window.location.href = ServiceManager.getRequired(ApplicationInformationService).serverVirtualDirectory + "api/processexport/getprocess/" + entityCommandInformation.getRecordId();
                })
        );
    }

    // #endregion

    // #endregion
    }

